import { render, staticRenderFns } from "./browserplug.vue?vue&type=template&id=5b1270a5&scoped=true&"
import script from "./browserplug.vue?vue&type=script&lang=js&"
export * from "./browserplug.vue?vue&type=script&lang=js&"
import style0 from "./browserplug.vue?vue&type=style&index=0&id=5b1270a5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1270a5",
  null
  
)

export default component.exports